{
  "theme": {
    "name": "Streaks-fallback",
    "cssVariables": [
      { "key": "--color-base-4", "value": "#000000" },
      { "key": "--color-base-3", "value": "#000C35" },
      { "key": "--color-base-2", "value": "#222a38" },
      { "key": "--color-base-1", "value": "#091324" },
      { "key": "--color-accent-1", "value": "#6bf5ff" },
      { "key": "--color-accent-2", "value": "#8B5CFF" },
      {
        "key": "--color-accent-3",
        "value": "linear-gradient(125deg, #6bf5ff 0%, #8B5CFF 100%)"
      },
      { "key": "--color-informative", "value": "#2388FB" },
      { "key": "--color-success", "value": "#2AC940" },
      { "key": "--color-warning", "value": "#FFBA5A" },
      { "key": "--color-error", "value": "#FF6666" },
      { "key": "--color-neutral", "value": "#FFFFFF" },
      { "key": "--color-surface-divider", "value": "#F2F3F7" },
      { "key": "--color-surface-muted", "value": "#D9D9D9" },
      { "key": "--color-surface-success-bright", "value": "#15BF81" },
      {
        "key": "--font-primary",
        "value": "'Korolev', system-ui, -apple-system, 'Segoe UI', sans-serif"
      },
      { "key": "--font-secondary", "value": "'Roboto Condensed', sans-serif" }
    ],
    "labels": [
      { "key": "streaks.title", "value": "World Cup Wheel" },
      { "key": "streaks.prize", "value": "Win up to #args0!" },
      {
        "key": "streaks.unlock",
        "value": "Submit #args0 games to unlock the Wheel and spin for rewards"
      },
      { "key": "streaks.progress", "value": "#args0/#args1 Games Played" },
      { "key": "streaks.reward", "value": "Free Spin" },
      { "key": "streaks.cta", "value": "Play Your Free Spin" },
      { "key": "streaks.step", "value": "G#args0" },

      { "key": "streaks.quiz.cards", "value": "Cards" },

      { "key": "streaks.featuredMatches.title", "value": "Featured Matches" },
      { "key": "streaks.featuredMatches.subtitle.match", "value": "Match" },
      { "key": "streaks.featuredMatches.subtitle.matches", "value": "Matches" },
      { "key": "streaks.featuredMatches.cta", "value": "Play Now" },

      { "key": "games.title", "value": "World Cup 2026" },
      { "key": "games.empty", "value": "No games available" },

      { "key": "howItWorks.title", "value": "How It Works" },
      { "key": "howItWorks.secondary", "value": "Secondary Info" },
      { "key": "howItWorks.step1.title", "value": "Play For Free" },
      {
        "key": "howItWorks.step1.copy",
        "value": "Discover a free and brand new game every day!"
      },
      { "key": "howItWorks.step2.title", "value": "Make Your Picks" },
      {
        "key": "howItWorks.step2.copy",
        "value": "Answer 8 simple multiple choice questions or pick 6 final scores"
      },
      { "key": "howItWorks.step3.title", "value": "Collect the Rewards" },
      {
        "key": "howItWorks.step3.copy",
        "value": "Return the next day to see if you've won the jackpot"
      },

      { "key": "wheel.almostThere", "value": "Almost there!" },
      { "key": "wheel.unlocked", "value": "You've unlocked a spin!" },
      {
        "key": "wheel.playMore",
        "value": "Play #args0 more game(s) to spin the wheel"
      },
      { "key": "wheel.reveal", "value": "Spin the wheel to reveal your prize" },
      { "key": "wheel.cta", "value": "Spin Now" },
      { "key": "wheel.prizes.title", "value": "Prizes" },

      { "key": "prizes.title", "value": "Prizes" },
      { "key": "prizes.freeSpins", "value": "Free Spins" },
      { "key": "prizes.freeBet", "value": "Free Bet" },
      { "key": "prizes.balanceCredit", "value": "Balance Credit" },
      { "key": "prizes.oddsBoost", "value": "Odds Boost" },
      { "key": "prizes.close", "value": "Close" },

      { "key": "results.noPrize", "value": "No prize" },
      { "key": "results.betterLuck", "value": "Better luck next time" },
      { "key": "results.awesome", "value": "Awesome!" },
      { "key": "results.won", "value": "You've won:" },
      {
        "key": "results.autoAdded",
        "value": "Your prize will be automatically added to your balance."
      },
      { "key": "results.playAgain", "value": "Play again" },
      { "key": "results.backToPlay", "value": "Back to play" },

      { "key": "iframe.loading", "value": "Loading game…" },

      { "key": "gameStatus.upcoming", "value": "Upcoming" },
      { "key": "gameStatus.playFree", "value": "Play For Free" },
      { "key": "gameStatus.editPicks", "value": "Edit Your Picks" },
      { "key": "gameStatus.pending", "value": "Pending Results" },
      { "key": "gameStatus.checkResults", "value": "Check Results" },
      { "key": "gameStatus.gameEnded", "value": "Game Ended" },
      { "key": "gameStatus.winUpTo", "value": "Win up to" },

      {
        "key": "error.gameLoad",
        "value": "Failed to load game. Please try again."
      },
      {
        "key": "error.tokenMissing",
        "value": "Token not found / gameId not found"
      },

      { "key": "streaks.history", "value": "Your History" },
      { "key": "streaks.locked", "value": "Locked" },
      { "key": "history.cta", "value": "History" },
      { "key": "history.loading", "value": "Loading history…" },
      { "key": "history.endedOn", "value": "Ended on" },
      { "key": "history.prizes", "value": "Prizes" },
      { "key": "history.yourPicks", "value": "Your Picks" },
      { "key": "history.editPicks", "value": "Edit Your Picks" },
      { "key": "history.endsOn", "value": "Ends on" },
      { "key": "history.tab.play", "value": "Play" },
      { "key": "history.tab.results", "value": "Results" },
      { "key": "history.paytable.title", "value": "Paytable" },
      {
        "key": "history.paytable.subtitle",
        "value": "Score cash prizes with just #args0 correct answers!"
      },
      { "key": "paytable.title", "value": "Paytable" },
      {
        "key": "paytable.info",
        "value": "Score cash prizes with just 3 correct answers!"
      },
      { "key": "history.empty.title", "value": "No history yet" },
      {
        "key": "history.empty.subtitle",
        "value": "Your played games will show up here."
      },
      { "key": "history.status.PENDING", "value": "Pending Results" },
      { "key": "history.status.SUBMITTED", "value": "Submitted" },
      { "key": "history.status.SETTLED", "value": "Settled" },
      { "key": "history.status.ENDED", "value": "Ended" },

      { "key": "a11y.close", "value": "Close" },
      { "key": "a11y.prizeWheel", "value": "Prize wheel" },
      { "key": "a11y.stake", "value": "Stake" },
      { "key": "a11y.tickets", "value": "Tickets" },
      { "key": "a11y.x0", "value": "X0" }
    ]
  }
}
